import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {CarnetDeTemps} from '../../../../model/Fields';
import {TicketsService} from '../../../../services/tickets.service';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import { AsyncPipe, CommonModule } from "@angular/common";
import {HoursPipe} from "../../../common/HoursPipe";
import {CdtInfosComponent} from "../../cdt-infos/cdt-infos.component";
import {DashBlockComponent} from "../dash-block.component";

@Component({
    selector: 'app-dash-block-cdt',
    templateUrl: './dash-block-cdt.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        HoursPipe,
        CdtInfosComponent,
        DashBlockComponent
    ],
    styleUrls: ['./dash-block-cdt.component.css']
})
export class DashBlockCdtComponent implements OnInit {

  showCdt = false;
  cdt$: Observable<CarnetDeTemps>;

  constructor(private ticketsService: TicketsService) {
  }

  ngOnInit(): void {
    this.cdt$ = this.ticketsService.getCarnetDeTemps();
  }

}
